/* eslint-disable unicorn/filename-case */
import { assertNever } from '@squareup/dex-utils-shared-assert-never';

import { PropertyCategory } from '../../../types';

export const usePropertyHeadingAnchor = (
  propertyCategory: PropertyCategory
): string => {
  switch (propertyCategory) {
    case PropertyCategory.Definitions:
      // Example URL: /objects/FloatNumberRange#properties
      return 'properties';
    case PropertyCategory.EventPayload:
      // Note: Firestorm-docs is using 'response-body' for this. We will do the same to avoid breaking links.
      // Example URL: /payments-api/webhooks/payment.created#response-body
      return 'response-body';
    case PropertyCategory.ErrorDescriptions:
      // Example URL: /payments-api/create-payment#error-descriptions
      return 'error-descriptions';
    case PropertyCategory.PathParameters:
      // Example URL: /payments-api/get-payment#path-parameters
      return 'path-parameters';
    case PropertyCategory.QueryParameters:
      // Example URL: /payments-api/list-payments#query-parameters
      return 'query-parameters';
    case PropertyCategory.RequestBody:
      // Example URL: /payments-api/update-payment#request-body
      return 'request-body';
    case PropertyCategory.ResponseFields:
      // Example URL: /payments-api/list-payments#response-body
      return 'response-body';
    // Example URL: /objects/FloatNumberRange#properties
    default:
      return assertNever(propertyCategory);
  }
};
